//DC ESTE CODIGO DEBE REFACTORIZARCE EN ALGUN MOMENTO
// 1. ubication         , es la ubicacion del usuario PERO que podemos mutar.
// 2. ubicationconfirmed, es la ubicacion confirmada por el usuario en el paso de busqueda. (NO DEBEMOS MUTARLA MAS QUE CUANDO TRANSICIONAMOS)
// 3. fullcercano, es el local mas cercano respecto de la ubicacion de la persona. (NO DEBEMOS MUTARLA MAS QUE CUANDO TRANSICIONAMOS)
// 4. localpivote, es el local mas cercano respecto de la ubicacion de la persona, PERO que podemos mutar.

import { useRoute } from "vue-router";
import { NEGOCIOS } from "~/constants/negocios";
import useGoogleServices from "~/composables/useGoogleServices";
import useUbicacionUsuario from "~/composables/useUbicacionUsuario";

export default function useMapaBuscadorGeneral(opciones = {}) {
  const { map_container_id = 'map' } = opciones

  const modo_sistema = useState('modo_sistema');

  const { 
    ubication,
    ubication_confirmed,
    fullcercano,
    localpivote: localPivoteStore,

    getLocalPivote,
    getUbicationConfirmed,
    getFullcercano,
    getUbication,
    getProducts,

    setUbication,
    setLocalPivote,
    setAddress,
    setShowAddressOptions,
    setShowLeaveAddress,
    setLeaveAddress,

  } = useCartBridge();

  const { seleccionarUbicacion, guardarUbicacion, obtenerLocalCercano, apiobtenerLocalCercano } = useUbicacionUsuario();

  const config = useRuntimeConfig();
  
  const debug = {
    enabled: config.public.modo === 'DEV',

    log(...args) {
      if (this.enabled) console.log(...args);
    },
    error(...args) {
      if (this.enabled) console.error(...args);
    },
  };

  //#region const, let, computed
  const { cargarGoogleMaps, cargarMarcadores, crearMapa: crearMapaGoogle, geocodificarCoordenadas, calcularRuta } = useGoogleServices('useMapaBuscadorGeneral');

  const route = useRoute();
  const { get_locales_full_erpapi } = useErpApi();
  const gps_state = ref(1);

  let map;
  let directionsDisplay;
  let markerOrigen;
  let markerDestino;
  let Locales_Base = [];
  let locales_map = ref([]);
  let markersTiendas = []
  let marcadoresTiendasHabilitados = true
  let filtroMarcadoresTiendas = null

  function limpiarMarcadoresTiendas() {
    try {
      markersTiendas.forEach((m) => {
        // AdvancedMarkerElement se quita seteando map = null
        try { m.map = null } catch (e) {}
        // (por si en algún entorno fuese Marker clásico)
        try { m.setMap && m.setMap(null) } catch (e) {}
      })
    } catch (e) {}
    markersTiendas = []
  }

  function configurarMarcadoresTiendas({ habilitar = true, filtro = null } = {}) {
    marcadoresTiendasHabilitados = !!habilitar
    filtroMarcadoresTiendas = (typeof filtro === 'function') ? filtro : null

    // Si se deshabilita, limpiar inmediatamente
    if (!marcadoresTiendasHabilitados) limpiarMarcadoresTiendas()
  }

  const normalizar_path = (p) => (p || '').replace(/\/+$/, '');

  const RUTAS_FLUJO_RAIZ = new Set([
    `/${NEGOCIOS.NEUMATICOS}`,
    `/${NEGOCIOS.BATERIAS}`,
    `/${NEGOCIOS.ACEITES}`,
    `/${NEGOCIOS.FRENOS}`,
    `/${NEGOCIOS.AFINAMIENTO}`,
    `/${NEGOCIOS.AMORTIGUADORES}`,
    `/${NEGOCIOS.TRENDELANTERO}`,
    `/${NEGOCIOS.ALINEACION}`,
    `/${NEGOCIOS.BALANCEO}`,
    `/${NEGOCIOS.GEOMETRIA}`,
    `/${NEGOCIOS.KILOMETRAJE}`,
    `/${NEGOCIOS.FLUIDOS}`,
    `/${NEGOCIOS.ELECTRICO}`,
    `/${NEGOCIOS.ACCESORIOS}`,
    `/${NEGOCIOS.REVISIONTECNICA}`,
    `/${NEGOCIOS.ACEITES}/local`, //  selector inline
  ]);

  const es_flujo_raiz = computed(() => {
    const ruta_actual = normalizar_path(route.path);
    return modo_sistema.value === NEGOCIOS.HOME || RUTAS_FLUJO_RAIZ.has(ruta_actual);
  });

  //#endregion

  //#region Consumo de apis
  const getAllStores = async (retries = 3) => {
    try {
      //locales-full
      const response = await get_locales_full_erpapi();
      const tiendas = JSON.parse(JSON.stringify(response));

      if (tiendas.length > 0) {
        // Usamos tiendas en lugar de response para la transformación
        // composables/useMapaBuscadorGeneral.js
        const transformedStores = tiendas.map((store) => {
          const foto = store.foto_fachada || store.imagen_url || store.imagen || store.image || null;

          return {
            id: store.local_id,
            alias: store.alias || store.alias_local || store.local_alias || null,

            // Mantén compatibilidad con lo que ya usas
            name: store.nombre_corto || store.nombre,
            comuna_nombre: store.comuna_nombre,
            fantasia: store.fantasia || 'no llegó',

            // Útil para tu nuevo componente
            address: store.direccion,
            direccion: store.direccion,

            textLocation: `${store.direccion} - ${store.comuna_nombre}`,
            schedule: [
              store.horario_semana,
              store.horario_findesemana ? store.horario_findesemana : "",
            ],
            status: store.abierto === "SI" ? "ABIERTO" : "CERRADO",
            telephone: store.tipo === "asociado" ? "+56950248569" : store.telefono,

            mapLocation: {
              lat: parseFloat(store.latitud),
              lng: parseFloat(store.longitud),
            },

            tipo: store.tipo || "leon",

            //  NUEVO: imagen
            foto_fachada: store.foto_fachada || null,
            imagen_url: foto,

            // (Opcional pero MUY útil) conservar raw para no volver a perder campos:
            _raw: store,
          };
        });

        return transformedStores;
      }

      // Si no hay datos pero quedan reintentos
      if (retries > 0) {
        await new Promise((resolve) => setTimeout(resolve, 500));
        return await getAllStores(retries - 1);
      }

      throw new Error("No se pudieron obtener las tiendas después de 3 intentos");
    } catch (error) {
      console.error("Error al obtener tiendas:", error);
      return [];
    }
  };

  //#endregion

  //#region Manejo de Tiendas
  function calcularDistanciaHaversine(lat1, lon1, lat2, lon2) {
    const earthRadiusKm = 6371;
    const deg2rad = (deg) => deg * (Math.PI / 180);

    const dLat = deg2rad(lat2 - lat1);
    const dLon = deg2rad(lon2 - lon1);

    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return earthRadiusKm * c;
  }

  async function sortByDistanceFormula(latitude, longitude) {

    try {
      const storesWithDistances = Locales_Base.map((store) => ({
        ...store,
        distance: calcularDistanciaHaversine(parseFloat(latitude), parseFloat(longitude), parseFloat(store.mapLocation.lat), parseFloat(store.mapLocation.lng)),
      }));

      let locales_ordenados = storesWithDistances.sort((a, b) => a.distance - b.distance);
      return locales_ordenados;
    } catch (error) {
      console.error("Error al calcular distancias:", error);
      return Locales_Base;
    }
  }

  async function render_locales(locationData, localpivote) {

    if (!Locales_Base || Locales_Base.length === 0) {
      return [];
    }

    // Ordenar por distancia si hay coordenadas
    let ordenados = [];
    if (locationData && locationData.latitude && locationData.longitude) {
      ordenados = await sortByDistanceFormula(locationData.latitude, locationData.longitude);
    } else {
      // Si no hay ubicación del usuario, usar Plaza de Armas como punto interno de referencia
      // pero sin mostrarlo al usuario
      const plazaDeArmasLat = -33.4378234;
      const plazaDeArmasLng = -70.6505019;

      ordenados = await sortByDistanceFormula(plazaDeArmasLat, plazaDeArmasLng);
    }

    let filtro = [];

    //tipo_filtro puede ser leones o primer_asociado

    if (es_flujo_raiz.value) {
      // NUEVO FILTRADO PARA RUTA RAÍZ:
      // 1. Primero el más cercano (sea león o asociado)
      // 2. Luego todos los león
      // 3. Después todos los asociados
      
      if (ordenados.length > 0) {
        const masCercano = ordenados[0]; // El primero es el más cercano
        const leones = ordenados.filter(store => store.tipo === "leon");
        const asociados = ordenados.filter(store => store.tipo === "asociado");
        
        // Crear el array final
        filtro = [masCercano]; // Comenzar con el más cercano
        
        // Agregar leones (excluyendo el más cercano si ya es león)
        leones.forEach(leon => {
          if (leon.id !== masCercano.id) {
            filtro.push(leon);
          }
        });
        
        // Agregar asociados (excluyendo el más cercano si ya es asociado)
        asociados.forEach(asociado => {
          if (asociado.id !== masCercano.id) {
            filtro.push(asociado);
          }
        });
      }
    } else {
      // Para otras rutas, mantener la lógica original
      // Si no hay localpivote, mostrar todos los locales del tipo correspondiente no deberia ocurrir pero si llegara a ocurrir
      if (!localpivote) {
        filtro = ordenados;
      } else if (localpivote.tipo == "asociado") {
        // primer asociado
        const primer_asociado = ordenados.find((store) => store.tipo === "asociado");
        filtro = primer_asociado ? [primer_asociado] : [];
      } else {
        // primer leon
        const primer_leon = ordenados.find((store) => store.tipo === "leon");
        filtro = primer_leon ? [primer_leon] : [];
      }
    }

    // Si después de filtrar no tenemos locales, mostrar al menos algunos
    if (filtro.length === 0) {
      // Mostrar los primeros 5 locales como fallback
      filtro = ordenados.slice(0, 5);
    }

    locales_map.value = filtro;
    return filtro;
  }
  //#endregion

  //#region Google Maps
  async function initializeMap() {
    try {
      await cargarGoogleMaps();
      if (!map) {
        crearMapa();
      }
      return true;
    } catch (error) {
      console.error("Error en :", error);
      return false;
    }
  }

  function crearMapa() {
    try {
      if (!directionsDisplay) {
        directionsDisplay = new google.maps.DirectionsRenderer();
      }

      if (!google || !google.maps) {
        console.warn("Google Maps not loaded yet");
        return null;
      }

      const mapContainer = document.getElementById(map_container_id);
      if (!mapContainer) {
        console.warn("Map container not found");
        return null;
      }

      let mapLat, mapLng;

      if (ubication.value?.latitude && ubication.value?.longitude) {
        mapLat = parseFloat(ubication.value.latitude);
        mapLng = parseFloat(ubication.value.longitude);
      } else {
        // Usar Plaza de Armas como centro del mapa cuando no hay ubicación
        mapLat = -33.4378234; // Plaza de Armas
        mapLng = -70.6505019; // Plaza de Armas
      }

      if (isNaN(mapLat) || isNaN(mapLng)) {
        console.error("Invalid coordinates:", { mapLat, mapLng });
        return null;
      }

      const mapOptions = {
        center: { lat: mapLat, lng: mapLng },
        zoom: 13,
        mapTypeControl: false,
        disableDefaultUI: true,
        mapId: "google-map-container", // Añadido mapId
      };

      map = crearMapaGoogle(mapContainer, mapOptions);

      if (!directionsDisplay) {
        directionsDisplay = new google.maps.DirectionsRenderer({
          suppressMarkers: true,
        });
      }

      return map;
    } catch (error) {
      console.error("Error creating map:", error);
      return null;
    }
  }

  async function crearMarcador(locationData) {
    try {
      // 1. Primero cargar la librería de marcadores
      await cargarMarcadores();

      const la_latitud = parseFloat(locationData.latitude);
      const la_longitud = parseFloat(locationData.longitude);

      if (!map || !google || !google.maps || isNaN(la_latitud) || isNaN(la_longitud)) {
        console.warn("Coordenadas o mapa inválidos", {
          la_latitud,
          la_longitud,
        });
        return;
      }

      const nuevaUbicacion = new google.maps.LatLng(la_latitud, la_longitud);

      if (markerOrigen) {
        markerOrigen.position = nuevaUbicacion;
      } else {
        const pin = document.createElement("div");
        pin.innerHTML = '<img src="/img/imagenes-popup-locales/home.webp" style="width: 1.8rem; height: 1.8rem; object-fit: contain;" alt="Ubicación" />';
        // 2. Ahora sí está disponible google.maps.marker
        markerOrigen = new google.maps.marker.AdvancedMarkerElement({
          position: nuevaUbicacion,
          map: map,
          title: "Ubicación actual",
          content: pin,
        });
      }

      map.setCenter(nuevaUbicacion);
      map.setZoom(13);
    } catch (error) {
      console.error("Error en crearMarcador:", error);
    }
  }

  function crearMarcadoresTiendas(locales_filtrados) {
    // Siempre limpiar antes para no “acumular” pins
    limpiarMarcadoresTiendas()

    if (!marcadoresTiendasHabilitados) return
    if (!map || !google?.maps?.marker?.AdvancedMarkerElement) return

    const lista = Array.isArray(locales_filtrados) ? locales_filtrados : []
    const listaFinal = filtroMarcadoresTiendas ? lista.filter(filtroMarcadoresTiendas) : lista

    listaFinal.forEach(function (store) {
      const lat = store?.mapLocation?.lat
      const lng = store?.mapLocation?.lng
      if (!Number.isFinite(lat) || !Number.isFinite(lng)) return

      const pin = document.createElement("div")
      pin.innerHTML = '<img src="/img/imagenes-popup-locales/marker.webp" style="width: 1.8rem; height: 1.8rem; object-fit: contain;" alt="Tienda" />'

      const marker = new google.maps.marker.AdvancedMarkerElement({
        position: { lat, lng },
        map,
        title: store?.name || '',
        content: pin,
      })

      markersTiendas.push(marker)
    })
  }

  function generarRuta(store) {
    let origenLat, origenLng;
    var destinoLat = store.mapLocation.lat;
    var destinoLng = store.mapLocation.lng;

    // Verificar si tenemos coordenadas de origen
    if (ubication.value?.latitude && ubication.value?.longitude) {
      origenLat = parseFloat(ubication.value.latitude);
      origenLng = parseFloat(ubication.value.longitude);
    } else {
      // Si no hay ubicación del usuario, usar Plaza de Armas como origen
      // (pero sin mostrarlo en el input)
      origenLat = -33.4378234; // Plaza de Armas
      origenLng = -70.6505019; // Plaza de Armas
    }

    if (map) {
      directionsDisplay.setMap(null);
    } else {
      map = crearMapaGoogle(document.getElementById(map_container_id), {
        zoom: 13,
        mapTypeControl: false,
        disableDefaultUI: true,
      });
    }

    // Marcador origen (solo si hay ubicación real del usuario)
    if (ubication.value?.address) {
      if (markerOrigen) {
        markerOrigen.position = new google.maps.LatLng(origenLat, origenLng);
      } else {
        const originPin = document.createElement("div");
        originPin.innerHTML = '<img src="/img/imagenes-popup-locales/home.webp" alt="Origen" />';
        markerOrigen = new google.maps.marker.AdvancedMarkerElement({
          position: { lat: origenLat, lng: origenLng },
          map: map,
          title: "Tu ubicación",
          content: originPin,
        });
      }
    }

    // Marcador destino
    if (markerDestino) {
      markerDestino.position = new google.maps.LatLng(destinoLat, destinoLng);
    } else {
      const destPin = document.createElement("div");
      destPin.innerHTML = '<img src="/img/imagenes-popup-locales/marker.webp" style="width: 2.4rem; height: 2.4rem; object-fit: contain;" alt="Destino" />';
      const pinOptions = {
        position: { lat: destinoLat, lng: destinoLng },
        map: map,
        title: store.name,
        content: destPin,
        zIndex: 500, // Esto asegurará que esté por encima
      };
      markerDestino = new google.maps.marker.AdvancedMarkerElement(pinOptions);
    }

    // Solo mostrar ruta si el usuario tiene una ubicación real
    if (ubication.value?.address) {
      directionsDisplay = new google.maps.DirectionsRenderer({
        polylineOptions: { strokeColor: "green" },
        suppressMarkers: true,
        map: map,
      });

      var request = {
        origin: { lat: origenLat, lng: origenLng },
        destination: { lat: destinoLat, lng: destinoLng },
        travelMode: google.maps.TravelMode.DRIVING,
      };

      calcularRuta(request)
        .then((result) => directionsDisplay.setDirections(result))
        .catch((error) => console.error("Error al obtener la ruta:", error));
    } else {
      // Si no hay ubicación real, centrar el mapa en la tienda
      map.setCenter({ lat: destinoLat, lng: destinoLng });
      map.setZoom(15);
    }
  }

  
  //  FIX (solo para flujos que mueven el DOM del mapa, p.ej. Teleport en mobile):
  // AdvancedMarkerElement a veces queda "desanclado" al cambiar el contenedor.
  // Esto fuerza eliminar y recrear los marcadores para que vuelvan a renderizarse.
  function reiniciarMarcadores() {
    const quitar = (m) => {
      if (!m) return;
      try {
        if (typeof m.setMap === "function") m.setMap(null);
        else if ("map" in m) m.map = null;
      } catch (e) {}
    };
    quitar(markerOrigen);
    quitar(markerDestino);
    markerOrigen = null;
    markerDestino = null;
  }

  async function generarRutaConMarcadoresRecreados(store) {
    try {
      // Asegurar librería marker disponible (AdvancedMarkerElement)
      await cargarMarcadores();
    } catch (e) {
      // Si falla, igual intentamos con la ruta normal
    }

    reiniciarMarcadores();
    return generarRuta(store);
  }

function eliminarRuta() {
    if (directionsDisplay) {
      directionsDisplay.setMap(null);
    }
  }
  //#endregion

  //#region Manejo de Ubicación
  async function secuencia_via_full_cercano(ubicacion_confirmada, local_mas_cercano) {

    try {
      const filtrados = await render_locales(ubicacion_confirmada, local_mas_cercano);
      debug.log("debug -> [COMPOSABLE MAPAGENERAL], locales filtrados segun ubicacion confirmada y local_mas_cercano, filtrados: ", filtrados);

      ultimaUbicacionProcesada = obtenerClaveUbicacion(ubicacion_confirmada);
      guardarUbicacion(ubicacion_confirmada, local_mas_cercano); // tengo dudas con esta ejecucion quizas deberia comentar

      eliminarRuta();
      crearMarcador(ubicacion_confirmada);
      crearMarcadoresTiendas(filtrados);
    } catch (error) {
      throw error;
    }
  }

  let ultimaUbicacionProcesada = null;

  function obtenerClaveUbicacion(ubi) {
    return `${ubi.latitude},${ubi.longitude},${ubi.address || ""}`;
  }

  async function sincronizarMapaConUbicacion(nuevaUbicacion) {
    if (!import.meta.client || nuevaUbicacion?.isLoading) return;

    if (!nuevaUbicacion?.latitude || !nuevaUbicacion?.longitude) {
      ultimaUbicacionProcesada = null;
      return;
    }

    const clave = obtenerClaveUbicacion(nuevaUbicacion);
    if (clave === ultimaUbicacionProcesada || Locales_Base.length === 0) return;

    ultimaUbicacionProcesada = clave;

    try {
      const filtrados = await render_locales(nuevaUbicacion, localPivoteStore.value);
      eliminarRuta();
      await crearMarcador(nuevaUbicacion);
      crearMarcadoresTiendas(filtrados);
    } catch (error) {
      console.error("Error al sincronizar el mapa con la ubicación:", error);
    }
  }

  // El mapa escucha la ubicación guardada, sin depender de quién la guardó
  watch(ubication, sincronizarMapaConUbicacion);

  async function getMyLocation() {
    const estadoInicial = ubication.value;
    
    const manejarFallo = () => {
      gps_state.value = 2;
      setUbication( {
        ...estadoInicial,
        isLoading: false,
      });
    };

    try {
      return await new Promise((resolve, reject) => {
        if (!navigator.geolocation) {
          manejarFallo();
          reject(new Error("Geolocalización no soportada"));
          return;
        }

        navigator.permissions.query({ name: "geolocation" }).then((permissionStatus) => {
          if (permissionStatus.state === "denied") {
            manejarFallo();
            reject(new Error("Permiso denegado"));
            return;
          }

          navigator.geolocation.getCurrentPosition(
            async (position) => {
              try {
                await getPosition(position);
                resolve(position);
              } catch (error) {
                manejarFallo();
                reject(error);
              }
            },
            (error) => {
              handleError(error);  // ← AQUÍ: solo para errores nativos de geolocalización
              manejarFallo();
              reject(error);
            },
            { enableHighAccuracy: true, timeout: 30000, maximumAge: 0 }
          );
        });
      });
    } catch (error) {
      manejarFallo();
      throw error;
    }
  }

  async function getPosition(position) {    
    try {
      const placeFormatted = await geocodificarCoordenadas(position.coords.latitude, position.coords.longitude);

      if (Locales_Base.length > 0) {
        await seleccionarUbicacion(placeFormatted, position.coords);
      } else {
        throw new Error("Sin datos de tiendas");
      }
    } catch (error) {
      console.error("Error in getPosition:", error);
      throw error; // Solo propagamos, el manejo lo hace getMyLocation
    }
  }

  const resetUbication = () => {
    let datareset = {
      isLoading: false,
      latitude: null,
      longitude: null,
      address: "",
      region: "",
      commune: "",
    };
    setUbication(datareset);
    setLocalPivote({});
  };

  const resetAddress = () => {
    setShowAddressOptions(false);
    setShowLeaveAddress(false);
    setAddress({
      region: "",
      commune: "",
      address: "",
      details: "",
      comments: "",
      latitude: null,
      longitude: null,
    });
  };

  const resetLeaveAddress = () => {
    setLeaveAddress({
      region: "",
      commune: "",
      address: "",
      details: "",
      comments: "",
      latitude: null,
      longitude: null,
    });
  };

  const handleError = (error) => {
      console.error("useMapaBuscadorGeneral.js -> error completo:", error);

      switch (error.code) {
          case 1: // PERMISSION_DENIED
              resetUbication();
              resetAddress();
              resetLeaveAddress();
              break;
          case 2: // POSITION_UNAVAILABLE
              resetUbication();
              resetAddress();
              resetLeaveAddress();
              break;
          case 3: // TIMEOUT
              resetUbication();
              resetAddress();
              resetLeaveAddress();
              break;
          default:
              console.error("Ocurrió un error desconocido al obtener la posición.", {
                  code: error.code,
                  message: error.message,
              });
      }
  };
  //#endregion

  //#region configuraciones maps
  async function Configurar_mapa() {

    try {
      // Si ya está todo inicializado, no hacer nada
      if (!window.google || !window.google.maps || !map) {
        await initializeMap();
      }
    } catch (error) {
      console.error("Error en :", error);
    }
  }
  //#endregion

  //#region inicial
  async function Callbackubicacion(){

    // Crear una ubicación vacía para mostrar al usuario
    const emptyLocation = {
      latitude: null,
      longitude: null,
      address: "", // Input vacío
      region: "",
      commune: "",
      isLoading: false,
    };

    // Establecer la ubicación vacía en el store
    setUbication(emptyLocation);

    // Pero internamente usar Plaza de Armas para ordenar (Sin mostrar esta ubicación al usuario)
    const internalLocation = {
      latitude: -33.4378234, // Plaza de Armas
      longitude: -70.6505019, // Plaza de Armas
      address: "", // Mantenemos vacío para no mostrar al usuario
      region: "",
      commune: "",
      isLoading: false,
    };

    // Obtener locales ordenados usando Plaza de Armas como referencia
    const defaultLocalpivote = await obtenerLocalCercano(internalLocation);
    await render_locales(internalLocation, defaultLocalpivote);
  }

  async function Obtener_locales_base(){
    if (!Locales_Base || Locales_Base.length === 0) {
      Locales_Base = await getAllStores();
    }
  }

  async function llamada_a_configurar(){
    resetUbication();
    await Configurar_mapa();
  }

  async function obtener_ubicacion(){
    try {
      await getMyLocation();
    } catch (error) {
      await Callbackubicacion();
    }
  }

  function Obtener_store() {
    getUbicationConfirmed();
    getLocalPivote();
    getFullcercano();
    getUbication();
    getProducts();
  }

  function Obtener_Ubication_confirmed_y_Fullcercano(){
    const ubication_confirmed_Local = ubication_confirmed.value;
    const fullcercano_local = fullcercano.value;

    debug.log("debug -> [COMPOSABLE MAPAGENERAL], ubication_confirmed_Local: ", ubication_confirmed_Local);
    debug.log("debug -> [COMPOSABLE MAPAGENERAL], fullcercano_local: ", fullcercano_local);

    const ubication_confirmed_Plano = { ...ubication_confirmed_Local };
    const fullcercano_Plano = { ...fullcercano_local };
    
    const data = {
      ubication_confirmed_Plano: ubication_confirmed_Plano,
      fullcercano_Plano: fullcercano_Plano
    };
    
    return data;
  }

  async function funcion_de_inicio() {
    try {
      debug.log("debug -> [COMPOSABLE MAPAGENERAL], route.path: ", route.path);
      debug.log("debug -> [COMPOSABLE MAPAGENERAL], modo_sistema.value: ", modo_sistema.value);
      if (es_flujo_raiz.value) {
        debug.log("debug -> [COMPOSABLE MAPAGENERAL], flujo raiz...");
        await Obtener_locales_base();
        debug.log("debug -> locales base obtenidos: ", Locales_Base);
        await llamada_a_configurar();
        await obtener_ubicacion();
      } else if (route.path.startsWith("/neumaticos/plp") || route.path.startsWith("/baterias/plp")) {
        debug.log("debug -> [COMPOSABLE MAPAGENERAL], flujo interno...");
        Obtener_store();
        await Obtener_locales_base();
        await llamada_a_configurar();
        const resultado = Obtener_Ubication_confirmed_y_Fullcercano();

        if (typeof resultado.ubication_confirmed_Plano?.latitude === "number" && typeof resultado.ubication_confirmed_Plano?.longitude === "number") {
          await secuencia_via_full_cercano(resultado.ubication_confirmed_Plano, resultado.fullcercano_Plano);
        } else {
          await obtener_ubicacion();
        }
      } 
    } catch (error) {
      console.error("Error en la inicialización:", error);
    }
  }
  //#endregion

  return { generarRuta, generarRutaConMarcadoresRecreados, reiniciarMarcadores, funcion_de_inicio, locales_map, gps_state, apiobtenerLocalCercano,
  configurarMarcadoresTiendas,
  limpiarMarcadoresTiendas, };
}